export enum WorkflowDownloadStatus {
    INITIALIZING = 'INITIALIZING',
    GENERATING = 'GENERATING',
    UPLOADING = 'UPLOADING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR'
}
